import * as FeedbackActions from './feedback.actions';
import { feedbackReducer } from './feedback.reducer';
import { feedbackSaga } from './feedback.saga';

export { feedbackReducer, FeedbackActions, feedbackSaga };
